'use client'

import { useContext } from 'react'

import { ConversationSidebarContext } from './ConversationSidebarContext'

const useConversationSidebarContext = () => {
  const context = useContext(ConversationSidebarContext)

  if (!context) {
    throw new Error(
      'useConversationSidebarContext must be used within a ConversationSidebarProvider',
    )
  }

  return context
}

export default useConversationSidebarContext
